import collectionsOptions from './collectionsProvider';

const selectOptionsMap = {
	CollectionsProvider: collectionsOptions,
};

export default selectOptionsMap;
